import { render, staticRenderFns } from "./OperateReocrd.vue?vue&type=template&id=d7f354c2&scoped=true&"
import script from "./OperateReocrd.vue?vue&type=script&lang=js&"
export * from "./OperateReocrd.vue?vue&type=script&lang=js&"
import style0 from "./OperateReocrd.vue?vue&type=style&index=0&id=d7f354c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f354c2",
  null
  
)

export default component.exports